import { FREE_SPIN_SUBTYPE } from 'common/constants';

export const getClientFreespinSubType = freeSpin =>
  freeSpin?.freeSpin?.freeSpinSubType ?? freeSpin?.freeSpinSubType ?? null;

// deposit freespins: use the expiry from the server when it exists. Everyone else: create time + time to use
export const resolveFreespinExpirationMs = freeSpin => {
  const subType = getClientFreespinSubType(freeSpin);
  const createTime = freeSpin?.createTime;
  const timeToUse = freeSpin?.freeSpin?.timeToUse;

  if (subType === FREE_SPIN_SUBTYPE.DEPOSIT && freeSpin?.expirationTime != null) {
    return freeSpin.expirationTime;
  }

  if (createTime != null && timeToUse != null) {
    return createTime + timeToUse;
  }

  return freeSpin?.expirationTime ?? createTime ?? null;
};
